import GameBodyComponentBase, {GameBodyComponentBaseParams} from '../../../../../components/game_body/game_body_component_base';
import DOM, {ElementSize} from '../../../../../utils/dom';
import NetEntGameEventListener from './netent_game_event_listener';
import NetEntExtend from '../../../../netent/netent_extend';
import {CyClass} from '../../../../../../../common/cy-classes';

export interface NetEntGameBodyComponentParams extends GameBodyComponentBaseParams {
    externalGameType: string;
    externalGameSubType: string;
    externalGameSessionId: string;
    gameServerUrl: string;
    casinoId: string;
    externalLanguageCode: string;
    showMiniLobby: boolean;
    hideExitGame: boolean;
}

export default class NetEntGameBodyComponent extends GameBodyComponentBase {
    static CLASS = 'NetEntGameBodyComponent';

    private _initParams: NetEntGameBodyComponentParams;
    private _netEntExtend: NetEntExtend;
    private _gameEventsListener: NetEntGameEventListener;

    init(params: NetEntGameBodyComponentParams) {
        super.init(params);
        this._initParams = params;
        this._createNetEntGamePlaceholder();
    }

    private _createNetEntGamePlaceholder(): void {
        const netEntGamePlaceholder = DOM.createElement('div');
        DOM.addAttribute(netEntGamePlaceholder, 'id', 'neGameClient');
        this.getEl().appendChild(netEntGamePlaceholder);
    }

    get _netEntGamePlaceholder(): HTMLElement {
        return this.querySelector('#neGameClient') as HTMLElement;
    }


    onAppendedToDOM() {
        super.onAppendedToDOM();

        this.serviceFactory.netEntService().launchGame({
            gameType: this._initParams.gameType,
            gameGroupId: this._initParams.gameGroupId,
            gameServerUrl: this._initParams.gameServerUrl,
            casinoId: this._initParams.casinoId,
            netEntGameType: this._initParams.externalGameType,
            netEntTableId: this._initParams.externalGameSubType,
            gameSessionId: this._initParams.externalGameSessionId,
            language: this._initParams.externalLanguageCode,
            showMiniLobby: this._initParams.showMiniLobby,
            hideExitGame: this._initParams.hideExitGame
        }).then(response => {
            this._netEntExtend = response.netEntExtend;

            DOM.addClass(this._netEntGamePlaceholder, 'cgp-game-iframe');
            DOM.addClass(this._netEntGamePlaceholder, CyClass('cy-game-iframe'));

            this._gameEventsListener = NetEntGameEventListener.create({
                netEntExtend: response.netEntExtend
            });

        }).catch(err => {
            this.logger.error(`Failed to launch NetEnt game ${this._initParams.gameType}`, err);
            this.serviceFactory.gameService().closeRunningGame();
            this.serviceFactory.messageManagerService().showGeneralErrorMessage();
        });
    }


    protected _setGameBodySize(gameSize: ElementSize): void {
        DOM.setElementSize(this.getEl(), gameSize);
    }


    stopAutoplay() {
        this._netEntExtend.stopAutoplay();
    }


    shutDown() {
        super.shutDown();

        if(this._gameEventsListener) {
            this._gameEventsListener.dispose();
        }
    }
}